import CommonHelmet from '@src/components/CommonHelmet';
import RegistrationCreateIndex from '@src/features/company/company-user/RegistrationCreate';
import CompanyNoMenusLayout from '@src/layouts/company/CompanyNoMenusLayout';

function CompanyRegistrationCreate() {
  return (
    <CompanyNoMenusLayout>
      <CommonHelmet />
      <RegistrationCreateIndex />
    </CompanyNoMenusLayout>
  );
}

export default CompanyRegistrationCreate;
